import { createSelector } from 'reselect';

const selectdbnagentsubscriptions = (state: any) => state.dbnagentsubscriptions;


export const selectdbnagentsubscriptionsCurrentItem = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.current);

export const selectdbnagentsubscriptionsListItems = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectdbnagentsubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectdbnagentsubscriptionsQueryItems = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.query);

export const selectdbnagentsubscriptionsCreatedItem = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.create);

export const selectdbnagentsubscriptionsUpdatedItem = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.update);

export const selectdbnagentsubscriptionsReadItem = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.read);

export const selectdbnagentsubscriptionsDeletedItem = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.delete);

export const selectdbnagentsubscriptionsSearchedItems = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.search);

export const selectdbnagentsubscriptionsItemsCount = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.count);

export const selectdbnagentsubscriptionsItemsFilter = createSelector([selectdbnagentsubscriptions], (dbnagentsubscriptions) => dbnagentsubscriptions.filter);